import TopBar from "./TopBar";
import LikesTabs from "consts/likesTabs";
export default () => {
	return <TopBar tabsEnum={LikesTabs} />;
};
